
// 默认背景
import { mapState } from 'vuex'
import bannerimg from '@/assets/img/class-banner1.png'
import allUrls from '@/utils/config'
import { urlEnhanceLang } from '@/utils/utils'
import link from '@/modules/config/link'
import gjUtmConfig from '@/utils/gjUtm'
import { ShippingProductClick } from '@/reporter/track'
import usOrder from '@/modules/templates/default/consign/components/usOrder.vue'


export default {
  components: {
    usOrder,
  },
  name: '',
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    bgUrl: {
      type: String,
      default() {
        return bannerimg
      },
    },
  },
  data() {
    return {
      bgUrls: this.bgUrl,
      isShow: null,
      gjUtm: gjUtmConfig.sfIntlOsSs1,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      site: (state) => state.site,
      loginToken: (state) => state.loginToken,
    }),
    iuopLink() {
      return link[this.site]
    },
  },
  watch: {
    bgUrl(val) {
      this.bgUrls = val
    },
  },
  created() {},
  mounted() {
    const querRoute = this.$route.query.isProduct
    if (window.isHideSFbuy && this.$route.path.includes('/sfbuy')) {
      this.isShow = false
    } else if (querRoute === 'product') {
      this.isShow = true
    }
  },
  methods: {
    trackFn(properties) {
      ShippingProductClick(properties)
    },
    handleConsignClick() {
      const site = this.site
      // 美国站点需要弹框选择下单类型
      if (site === 'us') {
        this.$refs.usOrderRef.openDialog()
      } else {
        this.jump()
      }
    },
    jump() {
      const { detail } = this.$route.params
      this.trackFn()
      if (detail === 'sfbuy') {
        // 只有顺丰集运跳转到sfbuy
        window.open(allUrls.sfbuyUrl)
      } else if (detail === 'warehouse') {
        // 海外仓
        if (window.iuopWarehouseFlag) {
          const loginToken = this.loginToken
          // 配置开关打开
          // 如果已登陆
          if (loginToken) {
            const iuopLoginingUrl = this.iuopLink.iuopLoginingUrl.replace(
              '{token}',
              loginToken
            )
            const url = urlEnhanceLang({
              lang: this.locale,
              url: iuopLoginingUrl,
              gjUtm: this.gjUtm[this.site],
            })
            window.open(url)
          } else {
            // 如果没有登陆
            const url = urlEnhanceLang({
              lang: this.locale,
              url: this.iuopLink.iuoploginUrl,
              gjUtm: this.gjUtm[this.site],
            })
            window.open(url)
          }
        } else {
          window.open(allUrls.wherpLoginUrl)
        }
      } else {
        const url = urlEnhanceLang({
          lang: this.locale,
          url: this.iuopLink.iuoploginUrl,
          gjUtm: this.gjUtm[this.site],
        })
        window.open(url)
      }
    },
  },
}
